import {useAppStore} from '@cohort/wallet/hooks/stores/app';
import {useUserStore} from '@cohort/wallet/hooks/stores/user';
import {useEffect, useRef} from 'react';
import {useLocation, useMatch, useNavigate} from 'react-router-dom';

export default function useEmbed(): void {
  const location = useLocation();
  const isLoggedIn = useUserStore(store => store.isLoggedIn);
  const embedded = useAppStore(store => store.embedded);
  const initialAuthState = useRef(isLoggedIn);
  const navigate = useNavigate();
  const isSpace = useMatch('/space/*');

  useEffect(() => {
    window.parent.postMessage(
      {
        event: 'location.updated',
        payload: {
          location: window.location.href,
        },
      },
      '*'
    );
  }, [location]);

  useEffect(() => {
    if (isSpace) {
      if (initialAuthState.current !== isLoggedIn) {
        window.parent.postMessage(
          {
            event: 'auth.updated',
            payload: {
              isLoggedIn,
            },
          },
          '*'
        );
        initialAuthState.current = isLoggedIn;

        if (embedded && !isLoggedIn) {
          navigate('/session-lost', {replace: true});
        }
      }
    }
  }, [isLoggedIn, isSpace, navigate, embedded]);
}
